// extracted by mini-css-extract-plugin
export default {"form":"BookForm_form__L2E3z","input":"BookForm_input__UNjFF","textarea":"BookForm_textarea__h2zMN","button":"BookForm_button__Tygxl"};